import React from 'react';

const TABS = [
  { id: 'activity', label: 'Activity' },
  { id: 'findings', label: 'Findings' },
  { id: 'photos',   label: 'Photos' },
  { id: 'unit',     label: 'Unit' },
  { id: 'customer', label: 'Customer' },
];

export default function LeftColumnTabs({ activeTab, setActiveTab, findingsCount, photosCount }) {
  const counts = { findings: findingsCount, photos: photosCount };
  return (
    <div className="ro-lcol-tabs">
      {TABS.map(t => (
        <button key={t.id}
          type="button"
          className={`ro-lcol-tab${activeTab === t.id ? ' ro-lcol-tab--active' : ''}`}
          onClick={() => setActiveTab(t.id)}>
          {t.label}{counts[t.id] ? ` (${counts[t.id]})` : ''}
        </button>
      ))}
    </div>
  );
}
